import { trigger, state, style, transition, animate } from '@angular/animations';

export const toggleIconAnim = trigger('toggleIconAnim', [
  state('visible', style({ opacity: 1, transform: 'scale(1)', visibility: 'visible' })),
  state('hidden', style({ opacity: 0, transform: 'scale(0.8)', visibility: 'hidden' })),
  transition('visible <=> hidden', animate('200ms ease')),
]);